<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { Button } from '../button';
import { cn } from '../ui-utils.ts';
import { useSidebar } from './utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();

const { toggleSidebar } = useSidebar();
</script>

<template>
  <Button
    type="button"
    data-sidebar="trigger"
    variant="ghost"
    size="icon"
    :class="cn('h-7 w-7', props.class)"
    @click="toggleSidebar"
  >
    <i class="fa-light fa-sidebar" />
    <span class="sr-only">Toggle Sidebar</span>
  </Button>
</template>
